/**
 * This file is used to determine the API url according to the environment set
 */

// const LOCAL_URL = 'http://localhost:5098';

const ENVIRONMENT = {
	STAGING: 'staging',
	PRODUCTION: 'production',
	QA: 'qa'
};

// Placeholders are replaced by docker-entrypoint.sh as per environment
const CURRENT_ENV = '__REACT_APP_NODE_ENV__';
const authUrl = '__REACT_APP_AUTH_SERVICE_BASE_URL__';
const adminUrl = '__REACT_APP_ADMIN_SERVICE_BASE_URL__';
const gClient = '__REACT_APP_GCLIENT_ID__';
const adminBasicAuth = '__REACT_APP_ADMIN_BASIC_AUTH__';

export const EXTERNAL_MERCHANT_PREFIX = 'https://crm-external.zupee.com';
const ENV_GCLIENT_MAP = {
	[ENVIRONMENT.STAGING]: gClient || '415377915708-v5m88liq9b1or1elc7k4slfk9q9bedo1.apps.googleusercontent.com',
	[ENVIRONMENT.PRODUCTION]: gClient || '519096840473-r7abmbvlmdvka454jjvpqaucpsa3715p.apps.googleusercontent.com',
	[ENVIRONMENT.QA]: gClient || '774098682266-osuphaqcsaqlp6v9435kgdeifmeendf1.apps.googleusercontent.com'
};
const ENV_AUTH_URL_MAP = {
	[ENVIRONMENT.STAGING]: authUrl || 'https://cse-auth-service.ludojoy.com',
	[ENVIRONMENT.PRODUCTION]: authUrl || 'https://auth.ludosupreme.com',
	[ENVIRONMENT.QA]: authUrl || 'https://auth-qa.ludojoy.com'
};

const ENV_ADMIN_URL_MAP = {
	[ENVIRONMENT.STAGING]: adminUrl || 'https://cse-admin-service.ludojoy.com',
	[ENVIRONMENT.PRODUCTION]: adminUrl || 'https://admin.ludosupreme.com',
	[ENVIRONMENT.QA]: adminUrl || 'https://admin-qa.ludojoy.com'
};

const ENV_ADMIN_BASIC_AUTH_MAP = {
	[ENVIRONMENT.STAGING]:
		adminBasicAuth || 'Basic enVwZWU6S1ZNTGxEQ2V1Y2ZOTm9TdWFSTlhPRFFJejVKNVBWUXBvM2VsSHFvcndYOXVmaEFGT21Hb0pVRDZTUHN4',
	[ENVIRONMENT.PRODUCTION]:
		adminBasicAuth || 'Basic c3VwcmVtZWx1ZG86U1gyb28wazZjY3JoRkxyMUtUZVlHSUFsdFRUd1hvanhmUFprbGNVVFRzY0RmYkw2QUNmYkgzWkowWHpz',
	[ENVIRONMENT.QA]: adminBasicAuth || 'Basic enVwZWU6aGVsbG93b3JsZA=='
};

const SIGN_UP_TRACKING_FIELDS = {
	[ENVIRONMENT.STAGING]: {
		TIMESTAMP: 'sign_up_game_time',
		LOCATION: 'sign_up_login_state',
		IP_ADDRESS: 'sign_up_login_ip'
	},
	[ENVIRONMENT.PRODUCTION]: {
		TIMESTAMP: 'first_game_time',
		LOCATION: 'first_login_state',
		IP_ADDRESS: 'first_login_ip'
	}
};

export default {
	ENVIRONMENTS: ENVIRONMENT,
	API_URL: ENV_AUTH_URL_MAP[CURRENT_ENV],
	GCLIENT_ID: ENV_GCLIENT_MAP[CURRENT_ENV],
	SIGN_UP_TRACKING_FIELDS: SIGN_UP_TRACKING_FIELDS[CURRENT_ENV],
	EXTERNAL_MERCHANT_PREFIX,
	ADMIN_API_URL: ENV_ADMIN_URL_MAP[CURRENT_ENV],
	ADMIN_BASIC_AUTH: ENV_ADMIN_BASIC_AUTH_MAP[CURRENT_ENV]
};
